import { DotLegalBreadCrumbModel } from "@dotlegal/dotlegal-ui-components";
import { useUrlProvider } from "../useUrlProvider.ts";
import { useTranslation } from "../localization/useTranslation.ts";
import { useState } from "react";
import { EmailCustomizationTypes } from "./EmailCustomization.types.ts";
import { IdNamePair } from "../customLists/customListView/CustomListView.types.ts";
import { setFirstLetterToLowerCase } from "../common/stringOperations.ts";

export function useEmailCustomization() {
    const urlProvider = useUrlProvider();

    const { translateString } = useTranslation();

    const [showUploadLogoDialog, setShowUploadLogoDialog] = useState(false);

    const getBreadCrumbs = () => {
        let breadCrumbs: Array<DotLegalBreadCrumbModel> = [];

        breadCrumbs.push({ name: translateString("emailConfiguration") });

        return breadCrumbs;
    };

    const getEmailCustomizationTypesArray = (): IdNamePair[] => {
        return Object.keys(EmailCustomizationTypes)
            .filter((key) => typeof EmailCustomizationTypes[key as any] === "number")
            .map((key) => ({
                id: EmailCustomizationTypes[key as keyof typeof EmailCustomizationTypes].toString(),
                name: translateString(`${setFirstLetterToLowerCase(key)}MailTemplate`),
            }));
    };

    return {
        showUploadLogoDialog,
        setShowUploadLogoDialog,
        getBreadCrumbs,
        getEmailCustomizationTypesArray,
    };
}
